import { authHeader, handleResponse } from '../helpers';
export const PaymentLimitExceededRptService = {
    fetchPaymentLimitExceededData
};

function fetchPaymentLimitExceededData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}MappingRpt/AutoTransactionReport`, requestOptions)
        .then(handleResponse);
}
